import { useTranslation } from "react-i18next"

export function useProductStatusTranslation(isValid?: boolean | undefined) {
  const { t } = useTranslation()

  if (isValid) {
    return t("Product.Configuration.StatusOK")
  }
  if (isValid === false) {
    return t("Product.Configuration.StatusNotOK")
  }
  return t("Product.Configuration.StatusNotAvailable")
}
